import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

interface Props {
  textClose?: string;
  classClose?: string;
  textConfirm?: string;
  classConfirm?: string;
  className?: string;
  refresh?: boolean;
  disabled?: boolean;
  show: boolean;
  init?: boolean;
  isInfoModal?: boolean;
  maxWidth?: number;
  children?: JSX.Element | JSX.Element[];
  close?: () => void;
  confirm?: () => void;
}

export function Modal(props: Props): JSX.Element {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [refresh, setRefresh] = useState(props.refresh);
  const [disabled, setDisabled] = useState(props.disabled);

  const close = (): void => {
    setIsSubmitted(true);
    props.close();
  };

  const confirm = (): void => {
    setIsSubmitted(true);
    props.confirm();
  };

  useEffect(() => {
    if (isSubmitted && props.init) {
      setIsSubmitted(false);
    }
  }, [props.init]);

  useEffect(() => {
    if (props.show) {
      setIsSubmitted(false);
    }
  }, [props.show]);

  useEffect(() => {
    setDisabled(props.disabled);
    setRefresh(props.refresh);
  }, [props]);

  if (!props.show) {
    return null;
  }
  return ReactDOM.createPortal(
    <div className={`modal ${props.className || ''}`}>
      <div className='modal-dialog' style={{ maxWidth: props.maxWidth }}>
        {props.isInfoModal
      && (
        <IconButton aria-label='close' data-cy='modal-close-button' className='info-close-btn' onClick={close}>
          <CloseIcon />
        </IconButton>
      )}
        <div className='modal-body' data-cy='modal-body-div'>
          {props.children}
        </div>

        {!props.isInfoModal && (
          <div className='modal-footer'>
            {props.textClose && (
              <button
                type='button'
                disabled={isSubmitted && disabled}
                className={props.classClose || 'btn btn-link'}
                onClick={close}
              >
                {props.textClose}
              </button>
            )}
            {props.textConfirm && (
              <button
                type='button'
                disabled={isSubmitted && disabled}
                className={props.classConfirm || 'btn btn-primary-game'}
                onClick={confirm}
                data-cy='modal-confirm-button'
              >
                {isSubmitted && refresh && (
                  <>
                    <span className='dbd-loader' />
                    &nbsp;&nbsp;
                  </>
                )}
                {props.textConfirm}
              </button>
            )}
          </div>
        )}
      </div>
    </div>,
    document.getElementById('modal-root'),
  );
}
